import { formatDateTime } from '../../utils/format.ts';

function DateCell({
  value,
  className,
}: {
  value?: Date | string;
  format?: string;
  className?: string;
}) {
  if (!value) {
    return null;
  }
  return <span className={className}>{formatDateTime(typeof value === "string" ? new Date(value) : value)}</span>;
}

export default DateCell;
